import { helper } from '@ember/component/helper';

export default helper(function shortYear([year]) {
  if (!year) {
    return '';
  }
  return String(year).slice(-2); // Extracts the last two digits
});
